import SuitCaseIcon from 'components/icons/SuitCaseIcon';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const jobGuide: FeatureGuide = {
    key: 'job',
    title: 'Job',
    icon: <SuitCaseIcon />,
    sections: [
        whatItIs(
            'The job groups everything belonging to one shipment - declarations, documents and the customer it is filed for.'
        ),
        howItHelps(
            'Filing against a job keeps the whole shipment together, so related paperwork stays traceable instead of sitting on its own.'
        ),
        tips([
            'Search by job reference to reuse an existing job instead of creating a duplicate.',
            "Create a new job when the shipment isn't tracked yet - your progress here is kept.",
        ]),
    ],
};
